import copy from 'copy-to-clipboard';
import { useRouter } from 'next/router';
import { useToast } from '@pairy/pds-react';
import { useCallback } from 'react';

import useFile from '@/hooks/queries/file/useFile';
import { appendQuerySuffix } from '@/utils/shareLink';
import useShareUrl from '@/hooks/useShareUrl';

const copyLinkType = {
  stibee: '?email=$%email%$',
  mailchimp: '?email=*|EMAIL|*',
  hubspot: '?email={{contact.email}}',
  salesforce: '?email={{Recipient.Email}}',
  activeCampaign: '?email=%EMAIL%',
  totle: '?email=m_email',
  gmail: '?email={{Email}}',
  none: '',
} as const;

type CopyLinkType = keyof typeof copyLinkType;

const useCopy = () => {
  const router = useRouter();
  const fileId = Number(router.query.fileId);

  const { data: hashId } = useFile(
    {
      fileId,
    },
    {
      enabled: Boolean(fileId),
      select: (data) => data.data.data.file.hashId,
    },
  );

  const toast = useToast();

  const { url: shareUrl } = useShareUrl({
    targetType: 'BULK_FILE',
    identifier: hashId ?? '',
  });

  const copyLink = useCallback(
    (linkType: CopyLinkType = 'none') => {
      if (hashId) {
        /* ESP 머지태그($%email%$, {{Email}} 등)는 인코딩되면 안 되므로
           URL 파서를 쓰지 않고 문자열로 결합한다. */
        copy(appendQuerySuffix(shareUrl, copyLinkType[linkType]));
        toast('링크가 복사되었습니다.');
      } else {
        toast.error(
          `공유 링크를 복사하는데 실패했습니다.\n새로고침 후 다시 시도해주세요.`,
        );
      }
    },
    [hashId, shareUrl],
  );

  return copyLink;
};

export default useCopy;
